import Loading from './../misc/Loading';
import React from 'react';
import DealerComponent from './Dealer';
import employeeModel from '../../../../model/employee';
import dealerModel from '../../../../model/dealer';
import makesModel from './../../../../model/makes';
import modelModel from './../../../../model/model';
import Services from './../../../../services/Services';
import ValidationError from '../../../../model/error/ValidationError';
import update from 'immutability-helper';
import withRouter from '/src/components/misc/withRouter';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Forhandleren validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av forhandler og handlingen kunne dermed ikke fullføres.';
};

class DealerContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dealer: null,
      models: null,
      allMakes: null,
      modified: false,
      working: false,
      error: null,
      tags: [],
      dealerCheck: {}
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateDealerState = this.updateDealerState.bind(this);
  }

  componentDidMount() {
    Promise.all([
      dealerModel.getById(this.props.match.params.dealerId, 2),
      employeeModel.getByDealer(this.props.match.params.dealerId, 1),
      makesModel.all(),
      dealerModel.query('fields.groupTags', {
        'fields.groupTags[exists]': true
      })
    ]).then((result) => {
      const dealer = result[0];

      document.title = `Admin - Forhandlerregister - ${dealer.name}`;

      // Need to fetch all dealers makes
      if (dealer.makes) {
        result.push(
          Promise.all(dealer.makes.map((make) => {
            return modelModel.modelsByMake(make.id).then((models) => {
              return {
                make: make,
                models: models
              };
            });
          }))
        );
      }

      return Promise.all(result);
    }).then((result) => {
      const dealer = result[0];
      const employees = result[1];
      const makes = result[2];
      const groupTags = result[3];
      const models = result[4];

      let tags = groupTags.items.reduce((res, tag) => {
        res.push(...tag.fields.groupTags['nb-NO']);

        return res;
      }, []);

      // Keep unique, and sort
      tags = [...new Set(tags)].sort();

      this.setState({
        dealer: dealer,
        employees: employees,
        models: models,
        allMakes: makes,
        tags: tags
      });

      // Do a check against the dealername in database (ad sync)
      Services.checkDealer(dealer.firmSyncName || dealer.name).then((response) => {
        this.setState({
          dealerCheck: response
        });
      }).catch(() => {
        this.setState({
          error: 'Feil ved sjekk av forhandler mot AD'
        });
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  updateDealerState(newDealer) {
    this.setState({
      dealer: newDealer
    });
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });
    dealerModel.save(this.state.dealer, 2).then((dealer) => {
      this.setState({
        working: false,
        dealer: dealer
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handlePublish() {
    this.setState({
      working: true
    });
    dealerModel.publish(this.state.dealer, 2).then((dealer) => {
      this.setState({
        working: false,
        dealer: dealer
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    dealerModel.unpublish(this.state.dealer.id, 2).then((dealer) => {
      this.setState({
        working: false,
        dealer: dealer
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.dealer) {
      return (
        <Loading title="Forhandler" text="Laster forhandler" />
      );
    }

    return (
      <DealerComponent
        dealer={this.state.dealer}
        dealerCheck={this.state.dealerCheck}
        employees={this.state.employees}
        allMakes={this.state.allMakes}
        models={this.state.models}
        modified={this.state.modified}
        working={this.state.working}
        tags={this.state.tags}
        error={this.state.error}
        makesModelsOpen={this.state.makesModelsOpen}
        employeesOpen={this.employeesOpen}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.handlePublish}
        onUnpublish={this.handleUnpublish}
        updateDealerState={this.updateDealerState}
        handleMakesModelPanel={this.handleMakesModelPanel}
        handleEmployeePanel={this.handleEmployeePanel}
      />
    );
  }
}

DealerContainer.defaultProps = {
  id: null
};

export default withRouter(DealerContainer);
